<template>
  <div>
    <b-modal
      id="modal-alert-media"
      modal-class="modal-notification"
      scrollable
      size="xl"
      centered
      @show="onShowModal"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center">
          <span> {{ formattedHeader }} </span>
          <i class="icon-outline_close" @click="close()" />
        </div>
      </template>
      <div class="mc-modal-alert-body__wrapper">
        <div class="mc-modal-alert__sidebar-column">
          <SectionAlertSidebar :detailNotification="detailNotification" />
          <AlertCommentCard
            class="modal-alert-media__comment-card"
            :note="mediaPopup.note"
            :user-logs="detailNotification?.userLogs ?? []"
            :save-action="saveNote"
            @input="handleNoteInput"
          />
        </div>
        <div v-if="loading" style="width: 100%">
          <b-skeleton width="60%" height="30px" />
          <b-skeleton width="100%" height="30px" class="mt-2" />
          <b-skeleton width="100%" height="390px" class="mt-3" />
          <div class="mt-3 d-flex gap-2">
            <b-skeleton width="100%" height="60px" />
            <b-skeleton width="100%" height="60px" />
            <b-skeleton width="100%" height="60px" />
            <b-skeleton width="100%" height="60px" />
            <b-skeleton width="100%" height="60px" />
            <b-skeleton width="100%" height="60px" />
            <b-skeleton width="100%" height="60px" />
          </div>
        </div>
        <SectionAlertMain
          v-else
          ref="sectionAlertMainRef"
          :vehicleCategory="detailNotification.vehicle.vehicleType.category"
          :vgroups="detailNotification.vehicle.vehicle2Vgroup ?? []"
          :driver="detailNotification.driver?.fullname ?? '-'"
          :statusText="statusText"
          :dvhData="listNotificationMedia"
          :device-type="getDeviceType(deviceCode)"
          :vehicle-id-cam="vehicleIdCam"
          :imei-cam="imeiCam"
          :alert-code="detailNotification.alert.alertCode"
          :raw-alert-created-on="detailNotification.createdOn"
          :raw-alert-id="detailNotification.rawAlertId"
          :checkIsDmsAdas="
            detailNotification.alert.alertCategories.some(
              ({ alertCategoryId }) => alertCategoryId === 3 || alertCategoryId === 4
            )
          "
        >
          <FalseAlertActionCard
            class="modal-alert-media__false-action"
            :popup="mediaPopup"
            :action-handlers="falseAlertActionHandlers"
            @form-change="handleFormChange"
          />
        </SectionAlertMain>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex align-items-center justify-content-between w-100">
          <b-dropdown
            class="modal-alert-media__action-dropdown"
            size="md"
            variant="outline-primary"
            no-caret
            dropup
            menu-class="modal-alert-media__action-menu"
          >
            <template #button-content>
              {{ $t('global.action.moreAction') }}
              <i class="mc-fa icon-outline_arrow-ios-down" />
            </template>

            <b-dropdown-item
              v-for="item in actionDropdownItems"
              :key="`${item.icon}-${item.label}`"
              @click="item.action()"
            >
              <span :class="item.isDangerVariant ? 'text-danger' : ''">
                <i :class="item.icon" class="font-size-16 align-middle me-1" />
                {{ $t(item.label) }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
          <div class="d-flex align-items-center">
            <McButton
              variant="outline-primary"
              class="me-2"
              :text="$t('global.action.close')"
              @click="cancel()"
            />
            <McButton
              variant="outline-primary"
              class="me-2 btn-download-all"
              icon="mc-fa icon-outline_download"
              :text="$t('global.action.downloadAll')"
              :disabled="dataMediaSuccess.length === 0"
              :loading="loadingDownload"
              @click="downloadAll()"
            />
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal-alert-media-action"
      :title="getModalTitle"
      ok-variant="primary"
      cancel-variant="outline-primary"
      :ok-title="$t('global.action.save')"
      :cancel-title="$t('global.action.cancel')"
      centered
      @ok="handleActionModalOk"
    >
      <p>{{ getModalText }}</p>
    </b-modal>
  </div>
</template>
<script>
import { GET_VEHICLE_STATUS_TEXT } from '@/services/api/trackvideo/video'
import { mapGetters, mapState } from 'vuex'
import SectionAlertSidebar from './SectionAlertSidebar.vue'
import SectionAlertMain from './SectionAlertMain.vue'
import McButton from '@/components/McButton'
import AlertCommentCard from '@/router/layouts/components/Vertical/AlertCenter/CommentCard.vue'
import FalseAlertActionCard from '@/router/layouts/components/Vertical/AlertCenter/FalseAlertActionCard.vue'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import {
  createAlertActionForm,
  createAlertActionContext,
  createFalseAlertActionHandlers,
  getAlertActionModalText,
  getAlertActionModalTitle,
  normalizeAlertNote,
  saveAlertNoteAction,
  saveAlertResolveAction,
  saveFalseAlertAction,
  waitModalHidden,
} from '@/router/layouts/components/Vertical/AlertCenter/lib/alert-actions'
import moment from 'moment'
moment.locale('id')

export default {
  components: {
    SectionAlertSidebar,
    SectionAlertMain,
    McButton,
    AlertCommentCard,
    FalseAlertActionCard,
  },
  mixins: [Helper, MixPanel],
  data() {
    return {
      statusText: null,
      deviceCode: null,
      loading: true,
      note: '',
      formOpen: false,
      form: createAlertActionForm(),
      isResolving: false,
      modalType: null,
      loadingDownload: false,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      vehicleIdsCallActive: 'voip/vehicleIdsCallActive',
    }),
    ...mapState('notification', ['detailNotification', 'listNotificationMedia']),
    dataRequested() {
      if (
        this.$store.state.notification.dataDvhRequested.length === 0 ||
        !this.detailNotification?.rawAlertId
      )
        return []
      return this.$store.state.notification.dataDvhRequested.filter((d) => {
        return d.rawAlertId
          ? String(d.rawAlertId) === String(this.detailNotification.rawAlertId)
          : new Date(d.startTime).getTime() === new Date(this.detailNotification.createdOn).getTime()
      })
    },
    dataMediaSuccess() {
      return [...this.listNotificationMedia, ...this.dataRequested].filter(
        (media) => media.status === 'S'
      )
    },
    isSalesDemo() {
      const email = this.$store.state.identity.whoami.email
      const demoStaging =
        email === 'mceasy-demo@vsms.co.id' &&
        (window.location.host === 'vsms2-staging.mceasy.cloud' ||
          window.location.host === 'localhost:3000')
      return (
        (demoStaging || window.location.host === 'demo.mceasy.com') &&
        this.$store.state.notification.detailNotification.isDemo
      )
    },
    actionDropdownItems() {
      if (!this.detailNotification?.rawAlertId) return []

      const callActive = this.vehicleIdsCallActive.includes(this.vehicleIdCam)
      const deviceType = this.getDeviceType(this.deviceCode)

      return [
        {
          icon: 'mc-fa icon-outline_file-text',
          label: 'Detail Notifikasi',
          visible: true,
          isDangerVariant: false,
          action: () => {
            this.openDetailNotification(this.detailNotification)
          },
        },
        {
          icon: 'mc-fa icon-outline_live-view',
          label: 'Live View Monitoring',
          visible: true,
          isDangerVariant: false,
          action: () => {
            window.open(
              this.buildLiveviewUrl({
                type: 'vehicle',
                vehicleId: this.detailNotification.vehicleId,
              }),
              '_blank'
            )
          },
        },
        {
          icon: 'mc-fa icon-outline_pin-history',
          label: 'global.object.tripHistory',
          visible: true,
          isDangerVariant: false,
          action: () => {
            const endDate = new Date()
            const startDate = new Date(endDate.getTime() - 60 * 60 * 1000)
            window.open(
              this.buildLiveviewUrl({
                type: 'history',
                vehicleId: this.detailNotification.vehicleId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
              }),
              '_blank'
            )
          },
        },
        {
          icon: 'mc-fa icon-outline_videorecord',
          label: 'menuitems.liveStreaming.text',
          visible: this.hasAccessAll([
            'b3h-new-trackvision-menu:read',
            'b3j-trackvision-live-streaming:read',
          ]),
          isDangerVariant: false,
          action: () => {
            window.open(
              `${window.location.protocol}//${window.location.host}/live-streaming/?vehicleId=${this.vehicleIdCam}`,
              '_blank'
            )
          },
        },
        {
          icon: 'mc-fa icon-outline_video-history',
          label: 'menuitems.videoHistory.text',
          visible: this.hasAccessAll([
            'b3h-new-trackvision-menu:read',
            'b3k-trackvision-video-history:read',
          ]),
          isDangerVariant: false,
          action: () => {
            const alertCreatedOn = new Date(this.detailNotification.createdOn)
            const now = new Date()
            const startTime = new Date(alertCreatedOn.getTime() - 10 * 60 * 1000)
            const endTime = new Date(
              Math.min(alertCreatedOn.getTime() + 10 * 60 * 1000, now.getTime())
            )
            window.open(
              `${window.location.protocol}//${
                window.location.host
              }/video-history/?${new URLSearchParams({
                vehicleId: this.vehicleIdCam,
                startTime: startTime.toISOString(),
                endTime: endTime.toISOString(),
              }).toString()}`,
              '_blank'
            )
          },
        },
        {
          icon: `mc-fa ${callActive ? 'icon-outline_phone-off' : 'icon-outline_phone'}`,
          label: callActive ? 'trackVideo.endCall' : 'notification.action.callDriver',
          visible:
            this.hasAccessAll([
              'b3f-two-way-communication:read',
              'b3f-two-way-communication-all-module:read',
            ]) &&
            (deviceType === 'bsj' || deviceType === 'vss-howen'),
          isDangerVariant: callActive,
          action: () => (callActive ? this.endCall() : this.startCall()),
        },
      ].filter(({ visible }) => visible)
    },
    mediaPopup() {
      return {
        id: this.alertStoreId,
        alert: this.detailNotification,
        formOpen: this.formOpen,
        form: this.form,
        note: this.note,
        isResolving: this.isResolving,
      }
    },
    falseAlertActionHandlers() {
      return createFalseAlertActionHandlers({
        openActionModal: (type) => this.openActionModal(type),
        markAsResolved: (status, actionType) => this.markAsResolved(status, actionType),
        setFormOpen: (formOpen) => this.setFormOpen(formOpen),
        setFalseAlertReason: (reason) => this.setFalseAlertReason(reason),
      })
    },
    alertStoreId() {
      return this.detailNotification?.id ?? this.detailNotification?.rawAlertId
    },
    getModalTitle() {
      return getAlertActionModalTitle(this.modalType, this.$t.bind(this))
    },
    getModalText() {
      return getAlertActionModalText(this.modalType, this.$t.bind(this))
    },
    vehicleIdCam() {
      if (!this.detailNotification) return null
      if (this.detailNotification.vehicle.children?.length) {
        return this.detailNotification.vehicle.children[0]?.id
      }
      return this.detailNotification.vehicleId
    },
    imeiCam() {
      if (!this.detailNotification) return null
      if (this.detailNotification.vehicle.children?.length) {
        return this.detailNotification.vehicle.children[0]?.imei
      }
      return this.detailNotification.vehicle.imei
    },
    formattedHeader() {
      return `${this.detailNotification.vehicle.licensePlate} - ${
        this.detailNotification?.alert
          ? this.$i18n.locale === 'id'
            ? this.detailNotification?.alert.descriptionIdn
            : this.detailNotification?.alert.descriptionEng
          : '-'
      }`
    },
  },
  methods: {
    endCall() {
      this.track('Modal Alert Media - VoIP End Call', {
        entryPoint: 'Modal Alert Media',
      })
      this.$store.dispatch('voip/endCall', {
        vehicleId: this.vehicleIdCam,
      })
    },
    startCall() {
      this.track('Modal Alert Media - VoIP Admin make a call', {
        entryPoint: 'Modal Alert Media',
        alertCode: this.detailNotification.alert.alertCode,
        alertDescription: this.detailNotification.alert.descriptionIdn,
      })
      this.$store.dispatch('voip/startNewCall', {
        dataNewCall: {
          vehicleId: this.vehicleIdCam,
          licensePlate: this.detailNotification.vehicle.licensePlate,
          driver: this.detailNotification.driver?.fullname ?? null,
          imei: this.imeiCam,
          deviceType: this.getDeviceType(this.deviceCode),
          entryPoint: 'modalAlertMedia',
        },
      })
    },
    buildLiveviewUrl(params) {
      const base = `${window.location.protocol}//${window.location.host}/liveview-2/`
      const query = new URLSearchParams(params).toString()
      return `${base}?${query}`
    },
    openDetailNotification(alert) {
      const alertId = alert?.rawAlertId
      if (!alertId) return

      const isSameRoute =
        this.$router.currentRoute.name === 'Notification Detail' &&
        this.$router.currentRoute.params.id == alertId

      if (isSameRoute) return

      const resolved = this.$router.resolve({
        name: 'Notification Detail',
        params: { id: alertId },
      })

      window.open(resolved.href, '_blank')
    },
    onShowModal() {
      this.resetActionState()

      if (this.isSalesDemo) {
        this.loading = true
        const sensor35 = this.detailNotification.vehicle.sensor.find(
          (sensor) => sensor.sensorCode === 35
        )
        this.statusText = sensor35?.statusText ?? '1,2,3,4'
        this.deviceCode = 6001
        this.loading = false
      } else {
        this.getDataTrackvision()
      }
    },
    async getDataTrackvision() {
      try {
        this.loading = true
        const { statusText, deviceCode } = await this.getStatusTextFromVehicle(this.vehicleIdCam)
        this.statusText = statusText
        this.deviceCode = deviceCode
        this.loading = false
      } catch (error) {
        this.$mcToast.error(this.$t('global.somethingWentWrong'))
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async getStatusTextFromVehicle(vehicleId) {
      const response = await this.$apollo.query({
        query: GET_VEHICLE_STATUS_TEXT,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            vehicleId: [vehicleId],
          },
        },
      })
      const data = response.data.vehicleVideoTrackers.vehicleVideoTrackers[0]
      return { statusText: data.statusText, deviceCode: data.vehicle.device.deviceCode }
    },
    resetActionState() {
      this.note = ''
      this.formOpen = false
      this.form = createAlertActionForm()
      this.isResolving = false
      this.modalType = null
    },
    setFormOpen(formOpen) {
      this.formOpen = formOpen
    },
    setFalseAlertReason(reason) {
      this.form = createAlertActionForm({ ...this.form, reason })
    },
    handleFormChange(form) {
      this.form = createAlertActionForm(form)
    },
    handleNoteInput(value) {
      this.note = this.normalizeNoteText(value)
    },
    normalizeNoteText(value) {
      return normalizeAlertNote(value, this.$t.bind(this))
    },
    getAlertActionContext({ note = this.note } = {}) {
      return createAlertActionContext({
        apollo: this.$apollo,
        store: this.$store,
        alert: this.detailNotification,
        popupId: this.alertStoreId,
        note,
        form: this.form,
        t: this.$t.bind(this),
        toast: this.$mcToast,
        track: (event, data) => this.track(event, data),
        fullname: this.$store.state.access.profile.fullname,
        trackLocation: 'Media Modal',
        alertName: this.detailNotification.alert.descriptionIdn,
      })
    },
    waitModalHidden(modalId) {
      return waitModalHidden(this.$root, modalId)
    },
    openActionModal(type) {
      const modalHidden = this.waitModalHidden('modal-alert-media-action')
      this.modalType = type
      this.$bvModal.show('modal-alert-media-action')
      return modalHidden
    },
    async handleActionModalOk(event) {
      event.preventDefault()

      const isSuccess = await this.handleModalAction()
      if (isSuccess) {
        this.$bvModal.hide('modal-alert-media-action')
      }
    },
    async handleModalAction() {
      switch (this.modalType) {
        case 'falseAlert':
          return this.saveFalseAlert(true, 'FalseAlert')
        case 'recheck':
          return this.saveFalseAlert(false, 'FalseAlert')
        case 'resolved':
          return this.markAsResolved(false, 'Resolve')
        default:
          return false
      }
    },
    async saveFalseAlert(isFalseAlert, actionType) {
      const isSuccess = await saveFalseAlertAction(this.getAlertActionContext(), {
        isFalseAlert,
        actionType,
      })

      if (!isSuccess) return false

      this.note = ''
      this.form = createAlertActionForm()
      this.formOpen = false

      return true
    },
    async markAsResolved(status, actionType) {
      this.isResolving = true

      try {
        const isSuccess = await saveAlertResolveAction(this.getAlertActionContext(), {
          status,
          actionType,
          trackEvent: 'Resolve Notification from Media Modal',
        })

        return isSuccess
      } finally {
        this.isResolving = false
      }
    },
    async saveNote(note = this.note) {
      const submittedNote = this.normalizeNoteText(note)
      const isSuccess = await saveAlertNoteAction(
        this.getAlertActionContext({ note: submittedNote }),
        {
          isFalseAlert: Boolean(this.detailNotification.isFalseAlert),
        }
      )

      if (!isSuccess) return false

      this.note = ''

      return true
    },
    getVideoLengthInSeconds(startTime, endTime) {
      return Math.abs(moment.duration(moment(startTime).diff(moment(endTime))).asSeconds())
    },
    checkIsPhoto(startTime, endTime) {
      const deviceType = this.getDeviceType(this.deviceCode)
      const seconds = this.getVideoLengthInSeconds(startTime, endTime)
      return deviceType === 'vss-howen'
        ? seconds === 2
        : deviceType === 'bsj'
        ? seconds === 1
        : null
    },
    isPhotoFromVideoFewS(media) {
      if (!media) return false
      return (
        media.identifier === 'V' &&
        media.status === 'S' &&
        this.checkIsPhoto(media.startTime, media.endTime)
      )
    },
    async doMultipleDownload(fileList) {
      for (let i = 0; i < fileList.length; i++) {
        await this.delay(250)
        await this.downloadFile(fileList[i].url, fileList[i].mediaFilename)
      }
    },
    async processingDownloadVideo(mediaVideo) {
      const hasScopeConvertVideo = this.hasAccess(['b3q-trackvision-convert-video-download:read'])
      if (!hasScopeConvertVideo) {
        await this.doMultipleDownload(mediaVideo)
        return
      }
      const res = await Promise.all(mediaVideo.map((item) => this.convertVideoAndGetFile(item.url)))

      const finalUrl = res
        .map((item, index) =>
          item
            ? {
                url: item.downloadUrl,
                mediaFilename: item.filename ?? mediaVideo[index].mediaFilename,
              }
            : null
        )
        .filter(Boolean)

      if (!finalUrl.length) return

      await this.doMultipleDownload(finalUrl)
    },
    async downloadAll() {
      try {
        this.loadingDownload = true
        const mediaPicture = this.dataMediaSuccess.filter((media) => media.identifier === 'P')
        const mediaVideo = this.dataMediaSuccess.filter(
          (media) =>
            (media.identifier === 'V' || media.identifier === 'R') &&
            !this.isPhotoFromVideoFewS(media)
        )
        const photoFromVideo = this.dataMediaSuccess.filter(
          (media) => media.identifier === 'V' || media.identifier === 'R'
        )
        if (mediaPicture.length) {
          await this.doMultipleDownload(mediaPicture)
        }
        if (mediaVideo.length) {
          await this.processingDownloadVideo(mediaVideo)
        }
        if (photoFromVideo.length) {
          await this.$refs.sectionAlertMainRef.$refs.sectionMediaRef.downloadPhotoFromVideoPreview()
        }
      } catch (error) {
        console.error(error)
        this.$mcToast.error('Something went wrong')
      } finally {
        this.loadingDownload = false
      }
    },
  },
}
</script>

<style lang="scss">
@import './style.scss';
</style>
